import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Mail: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2019 4.4519C2.8114 3.84241 3.63805 3.5 4.5 3.5H19.5C20.362 3.5 21.1886 3.84241 21.7981 4.4519C22.4076 5.0614 22.75 5.88805 22.75 6.75V6.99289V17.25C22.75 18.112 22.4076 18.9386 21.7981 19.5481C21.1886 20.1576 20.362 20.5 19.5 20.5H4.5C3.63805 20.5 2.8114 20.1576 2.2019 19.5481C1.59241 18.9386 1.25 18.112 1.25 17.25V6.99461V6.75C1.25 5.88805 1.59241 5.0614 2.2019 4.4519ZM3.25 6.75V6.994C3.25 6.99391 3.25 6.99409 3.25 6.994C3.25002 7.20732 3.30464 7.41747 3.40865 7.60372C3.51269 7.79003 3.6627 7.9466 3.84438 8.05852C3.84436 8.05851 3.8444 8.05853 3.84438 8.05852L11.344 12.6723C11.5411 12.7937 11.7685 12.8582 12 12.8582C12.2315 12.8582 12.4584 12.794 12.6556 12.6726L20.1556 8.05756C20.3373 7.94563 20.4873 7.78905 20.5914 7.60272C20.6954 7.41647 20.75 7.2067 20.75 6.99338C20.75 6.99329 20.75 6.99347 20.75 6.99338V6.75C20.75 6.41848 20.6183 6.10054 20.3839 5.86612C20.1495 5.6317 19.8315 5.5 19.5 5.5H4.5C4.16848 5.5 3.85054 5.6317 3.61612 5.86612C3.3817 6.10054 3.25 6.41848 3.25 6.75ZM20.75 10.0401L13.7044 14.3754C13.7043 14.3755 13.7046 14.3754 13.7044 14.3754C13.1921 14.691 12.6017 14.8582 12 14.8582C11.3983 14.8582 10.8084 14.6912 10.296 14.3757L3.25 10.041V17.25C3.25 17.5815 3.3817 17.8995 3.61612 18.1339C3.85054 18.3683 4.16848 18.5 4.5 18.5H19.5C19.8315 18.5 20.1495 18.3683 20.3839 18.1339C20.6183 17.8995 20.75 17.5815 20.75 17.25V10.0401Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Mail;
